import { path } from 'ramda';

import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';

import Header from '../../components/Header';
import Inbox from '../../components/Inbox';
import LeftBar from '../../components/LeftBar';
import RouteBlockageDetail from '../../components/RouteBlockageDetail';
import { hideSnackbarMessage } from '../../modules/actions/layout';
import { selectSnackbarMessage } from '../../modules/selectors/layout';
import { selectUserId } from '../../modules/selectors/session';

import { readEndpointAllPages, readEndpointDedup } from '../../modules/reducers/api';

import 'roboto-npm-webfont/full/style.scss';
import './default.scss';


class AppBase extends Component {
  static propTypes = {
    // own props.
    children: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,

    // state props.
    snackbarMessage: PropTypes.string,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

    // dispatch props.
    hideSnackbarMessage: PropTypes.func.isRequired,
    readEndpointAllPages: PropTypes.func.isRequired,
    readEndpointDedup: PropTypes.func.isRequired,
  };

  static defaultProps = {
    snackbarMessage: null,
  };

  frequentIntervalLastTimestamp = 0;

  componentDidMount() {
    const { readEndpointAllPages, readEndpointDedup, userId } = this.props;

    /**
     * Fetch common data from the API that's required by several components,
     * such as the map layers and the inbox.
     */
    readEndpointDedup('railway');
    readEndpointDedup('stop');
    readEndpointAllPages('company?filter[deleted-at__isnull]=True');
    readEndpointDedup('vehicle?filter[deleted-at__isnull]=True');

    if (userId) {
      readEndpointDedup(`api-user/${userId}`);
      readEndpointDedup(`api-role?filter[user__exact]=${userId}`);
    }

    readEndpointDedup('route-blockage?recent=True').then(json => {
      const rbs = path(['data'], json) || [];
      const rbsIds = rbs.map(rb => rb.id);

      if (rbsIds.length > 0) {
        readEndpointAllPages(`reserved-vehicle?page_size=50&filter[routeblockage__in]=${rbsIds.join(',')}`);
        readEndpointAllPages(`invited-driver?page_size=50&filter[routeblockage__in]=${rbsIds.join(',')}`);
        readEndpointAllPages(`ride?page_size=50&filter[routeblockage__in]=${rbsIds.join(',')}`);
      }
    });
    readEndpointDedup('dashboard-message');

    /**
     * Fetch common data that does not change frequently every 30 minutes.
     */
    this.infrequentInterval = setInterval(async () => {
      await readEndpointDedup('railway');
      await readEndpointDedup('stop');
      await readEndpointAllPages('company?filter[deleted-at__isnull]=True');
      await readEndpointDedup('vehicle?filter[deleted-at__isnull]=True');
      if (userId) {
        await readEndpointDedup(`api-user/${userId}`);
        await readEndpointDedup(`api-role?filter[user__exact]=${userId}`);
      }
    }, 30*60*1000);

    /**
     * Fetch common data that changes frequently every 10 seconds.
     */
    this.frequentIntervalLastTimestamp = 0;
    this.frequentInterval = setInterval(async () => {
      const json = await readEndpointDedup('route-blockage?recent=True');
      const rbs = path(['data'], json) || [];
      const rbsIds = rbs.map(rb => rb.id);

      const apiCallQueryString = `?page_size=50&filter[routeblockage__in]=${rbsIds.join(',')}` +
        `&filter[updated_at__gte]=${this.frequentIntervalLastTimestamp}`;

      if (rbsIds.length > 0) {
        await readEndpointAllPages(`reserved-vehicle${apiCallQueryString}`);
        await readEndpointAllPages(`invited-driver${apiCallQueryString}`);
        await readEndpointAllPages(`ride${apiCallQueryString}`);
      }

      await readEndpointDedup('dashboard-message');
      this.frequentIntervalLastTimestamp = (new Date()).getTime();
    }, 10*1000);
  };

  componentWillUnmount() {
    clearInterval(this.frequentInterval);
    clearInterval(this.infrequentInterval);
  };

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs>
            <Header title={this.props.title} />
          </Col>
        </Row>
        <Row style={{paddingTop: 65}}>
          <Col width={60} className="no-user-select">
            <LeftBar />
          </Col>
          <Col xs>
            <Inbox />
            {this.props.children}
            <RouteBlockageDetail />
            <Snackbar
              open={!!this.props.snackbarMessage}
              message={this.props.snackbarMessage || ''}
              autoHideDuration={4000}
              onClose={this.props.hideSnackbarMessage}
            />
          </Col>
        </Row>
      </Grid>
    );
  };
}


const mapStateToProps = state => ({
  snackbarMessage: selectSnackbarMessage(state),
  userId: selectUserId(state),
});

const mapDispatchToProps = {
  readEndpointAllPages,
  readEndpointDedup,
  hideSnackbarMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppBase);
